import { SyntheticEvent } from 'react';
import { Control, Controller } from 'react-hook-form';
import 'primereact/inputtextarea/inputtextarea.min.css';
import cn from 'classnames';

import classes from './textarea.module.scss';

export type TextareaProps =  {
  id?: string;
  name: string;
  value?: string;

  autoFocus?: boolean;
  placeholder?: string;
  disabled?: boolean;

  rows?: number;
  cols?: number;
  maxLength?: number;

  isRequired?: boolean;
  labelClassName?: string;
  rootClassName?: string;
  textareaClassName?: string;

  fieldId: string;
  hint?: string;
  label: string;
  error?: string;

  control?: Control<any>;

  onChange?: (e: SyntheticEvent)=> void;
  onBlur?: (e: SyntheticEvent)=> void;
};

const SimpleTextarea = (props: TextareaProps) =>
  <div className={cn(classes.root, props.rootClassName)}>
    <label htmlFor={props.fieldId} className={cn(classes.label, props.labelClassName)}>
      {props.label}
      {props.label && props.isRequired ? <span className={classes.asterix}>*</span> : null}
    </label>
    <textarea
      id={props.fieldId}
      name={props.name}
      value={props.value}
      maxLength={props.maxLength}

      autoFocus={props.autoFocus}
      placeholder={props.placeholder}
      disabled={props.disabled}

      rows={props.rows}
      cols={props.cols}

      className={cn(classes.textarea, props.textareaClassName, { [classes.textareaError]: props.error })}

      onChange={props.onChange}
      onBlur={props.onBlur}
    />
    <small className={props.error ? classes.error : classes.hint}>{props.error ? props.error : props.hint}</small>
  </div>

export const Textarea = (props: TextareaProps) => (
  !props.control
    ? <SimpleTextarea {...props} />
    : <Controller render={({ field: { ref, ...field } }) => <SimpleTextarea {...props} {...field} /> }
                  name={props.name}
                  control={props.control}
    />
);

Textarea.defaultProps = {
  rows: undefined,
  cols: undefined,
};
